<div
  [class.rpt-standard-table-wrap]="useRegistryTableChrome"
  [class.rpt-registry-v2-skin]="useRegistryTableChrome">
  <p-table
  #table
  [styleClass]="getTableClass()"
  [scrollable]="scrollable"
  [scrollHeight]="scrollHeight"
  [(selection)]="tableSelection"
  [autoLayout]="autoLayout"
  [rowGroupMode]="groupRowsBy ? rowGroupMode : undefined"
  [groupRowsBy]="groupRowsBy"
  [responsiveLayout]="responsiveLayout"
  [selectionMode]="selectable ? resolvedSelectionMode : null"
  [dataKey]="dataKey"
  [value]="loading ? skeletonItems : inplaceSort ? (values | orderBy: sort) : values"
  crmVisualSelectedRowsTable
  [isVisualSelected]="isVisualSelected"
  [keySelectedRows]="name"
  crmVisualSelectedColumnsTable
  [keySelectedColumns]="name"
  [paginationLoading]="paginationLoading"
  [isVisualSelectedColumns]="isVisualSelectedColumns">
  @if (filterColumns || captionTemplate) {
    <ng-template pTemplate="caption">
      <div class="flex flex-wrap gap-2 justify-content-between align-items-center">
        @if (filterColumns) {
          <div
            class="flex-none"
            style="width: 300px">
            <crm-multi-select
              [options]="columns | filterEmpty: 'name'"
              [selectedItems]="selectedColumns | filterEmpty: 'name'"
              (panelHide)="setFilterColumns($event)"
              [showHeader]="false"
              [showClear]="false"
              optionDisabled="required"
              sort="order"
              optionLabel="label"
              placeholder="Выберите столбцы"
              optionValue="name"
              display=""
              appendTo="body">
            </crm-multi-select>
          </div>
        }

        @if (captionTemplate) {
          <div class="flex-grow-1">
            <ng-template [ngTemplateOutlet]="captionTemplate"></ng-template>
          </div>
        }
      </div>
    </ng-template>
  }

  <ng-template pTemplate="header">
    @if (headerTemplate) {
      <ng-template
        [ngTemplateOutlet]="headerTemplate"
        [ngTemplateOutletContext]="{
          selectedColumns: selectedColumns,
          currentSort: sort,
          onSortChange: onCustomHeaderSort
        }"></ng-template>
    } @else {
      @if (scrollable ? !loading : true) {
        <tr>
          @if (selectable) {
            <th
              [attr.data-column-selectable]="'true'"
              style="width: 40px !important">
              @if (!isSingleSelection) {
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              }
            </th>
          }

          @for (column of selectedColumns | orderBy: 'order:number'; track column) {
            <th
              [ngStyle]="column.style"
              pFrozenColumn
              [frozen]="column.isFrozen"
              [ngClass]="column.class">
              <ng-template
                [ngTemplateOutlet]="columnTemplate"
                [ngTemplateOutletContext]="{ column: column }"></ng-template>
            </th>
          }

          <ng-template
            #columnTemplate
            let-column="column">
            <ng-container *ngIf="toColumn(column) as column">
              <div class="flex gap-1 align-items-center flex-nowrap w-full">
                @if (column.sort) {
                  <div
                    (click)="setSort(column.sort)"
                    class="cursor-pointer flex gap-1 justify-content-center align-items-center flex-nowrap {{
                      column.textStyleClass
                    }}">
                    <span
                      [class.cursor-help]="column.titleHint"
                      [pTooltip]="column.titleHint"
                      [tooltipDisabled]="!column.titleHint"
                      tooltipPosition="top">{{ column.label }}</span>
                    @if (column.additionalProperty) {
                      <span
                        class="pi pi-question-circle text-color-secondary cursor-help"
                        [pTooltip]="column.additionalProperty"
                        tooltipPosition="top"></span>
                    }
                    <i [ngClass]="getSortIconClass(column.sort)"></i>
                  </div>
                } @else {
                  <span
                    [class.cursor-help]="column.titleHint"
                    [pTooltip]="column.titleHint"
                    [tooltipDisabled]="!column.titleHint"
                    tooltipPosition="top">{{ column.label }}</span>
                  @if (column.additionalProperty) {
                    <span
                      class="pi pi-question-circle text-color-secondary cursor-help"
                      [pTooltip]="column.additionalProperty"
                      tooltipPosition="top"></span>
                  }
                }
              </div>
            </ng-container>
          </ng-template>
        </tr>
      }
    }
  </ng-template>

  <ng-template
    pTemplate="groupheader"
    let-item
    let-rowIndex="rowIndex">
    @if (groupheaderTemplate) {
      <ng-template
        [ngTemplateOutlet]="groupheaderTemplate"
        [ngTemplateOutletContext]="{
          item: item,
          rowIndex: rowIndex
        }"></ng-template>
    }
  </ng-template>

  <ng-template
    pTemplate="body"
    let-item
    let-rowIndex="rowIndex">
    @if (!loading) {
      @if (selectable) {
        <tr>
          <td style="width: 40px !important">
            @if (isSingleSelection) {
              <p-tableRadioButton
                [value]="item"
                (click)="$event.stopPropagation()"></p-tableRadioButton>
            } @else {
              <p-tableCheckbox
                #tableCheckbox
                [value]="item"
                [disabled]="selectionDisabled && !tableCheckbox.checked"
                (click)="$event.stopPropagation()"></p-tableCheckbox>
            }
          </td>
          <ng-template
            [ngTemplateOutlet]="rowTemplate"
            [ngTemplateOutletContext]="{
              item: item,
              rowIndex: rowIndex,
              selectedCols: selectedColumnsMap
            }"></ng-template>
        </tr>
      } @else {
        <ng-template
          [ngTemplateOutlet]="rowTemplate"
          [ngTemplateOutletContext]="{
            item: item,
            rowIndex: rowIndex,
            selectedCols: selectedColumnsMap
          }"></ng-template>
      }
    } @else {
      <tr>
        @if (selectable) {
          <td>
            @if (isSingleSelection) {
              <p-tableRadioButton [disabled]="true"></p-tableRadioButton>
            } @else {
              <p-tableCheckbox [disabled]="true"></p-tableCheckbox>
            }
          </td>
        }

        @for (col of selectedColumns; track col) {
          <td>
            <p-skeleton
              [shape]="col.skeleton?.shape"
              [height]="col.skeleton?.height || '1rem'"></p-skeleton>
          </td>
        }
      </tr>
    }
  </ng-template>

  <ng-template pTemplate="footer">
    @if (paginationLoading) {
      <tr class="crm-table-pagination-loading">
        <td
          [colSpan]="selectable ? columns.length + 1 : columns.length"
          class="text-center">
          <crm-spinner
            text=""
            top=""
            bottom=""
            [width]="28"
            [height]="28"></crm-spinner>
        </td>
      </tr>
    }
    <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td [attr.colspan]="emptyMessageColSpan">
        <div class="no-results w-full">
          <crm-no-data></crm-no-data>
          <h2 class="font-normal">По вашему запросу ничего не найдено</h2>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
</div>
